<template>
  <list-layout :tableTools="toggleTableTools">
    <template slot="header">
      <BaseHeader :content="header" />
    </template>
    <template slot="table-core">
      <base-table-pagination
        ref="baseTablePagRef"
        :total="pagination.total"
        :currentPage="pagination.currentPage"
        :perPage="pagination.pageSize"
        @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"
      ></base-table-pagination>
      <div class="flex flex-row w-100">
        <base-table-refresh @applyFilters="applyFiltersHandler" />
        <base-table-searches @toggleSearchesDialog="toggleSearchesDialog" />
        <base-table-search @toggleFilters="toggleFilters" />
      </div>
    </template>
    <template slot="table-tags">
      <base-table-filter-tags  :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
    </template>
    <template slot="table-component">
      <kendo-grid-component class="kendo-pointer-default"
              :spanish="spanish"
              :dataResult='kendo.dataResult'
              :kendo="kendo"
              :loading='isGeneralLoading'
              :selectedField="selectedField"
              @datastatechange='dataStateChange'
              @columnreorder='columnReorder'
              @rowclick='openPath'
              @columnssubmit='onColumnsSubmit'
              @sortchange='sortChange'
              @filterchange='filterChange'
              @selectionchange="onSelectionChange"
              @headerselectionchange="onHeaderSelectionChange">
            </kendo-grid-component>
    </template>
    <template slot="layout-extend">
      <base-table-select-actions
        :visibility="hasSelected"
        :selected="rowsSelected"
        :total="rowsTotal"
        :baseDropDownVisible="hasSelected"
      >
        <template slot="commons">
          <base-button :disabled="!hasSelected" size="xs" mode="tools" @click="unselect">
            <base-icon name="vall" size="sm" class="mr-1" :ariaHidden="true"/>
            {{ $t('app.unselect') }}
          </base-button>
        </template>
        <template slot="more">
          <base-button-item-list theme="dark" @click="unlink">
            <base-icon name="unlink" class="mr-2" :ariaHidden="true"/>
              Desvincular
          </base-button-item-list>
        </template>
      </base-table-select-actions>
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode='primary' :text="labelBtnExcel" icon='excelxls' @click='exportExcel' 
            :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel"/>
          <base-button-responsive mode='primary' :text="$t('configurations.delete_temporal')" icon='unlink' @click='deleteTemporal' 
            :loading='isGeneralLoading' :disabled="isGeneralLoading"/>
          <base-button-responsive mode='primary' :text="$t('configurations.add_temporal_groups')" icon='link' @click='toggleAddTemporal' 
            :loading='isGeneralLoading' :disabled="isGeneralLoading"/>
          <base-button-responsive mode="primary" :text="$t('configurations.link_group')" icon="plus" @click="golinkTagToUser" 
            :loading="isGeneralLoading"/>
        </template>
      </base-footer>
      <user-link-groups-dialog 
        :dialogOpen="linkGroupToUserDialog" 
        :userId="this.$route.params.id" 
        @toggleDialog="toggleDialogs" 
        @applyDialog="applyLinkHandler" 
        />
      <user-link-users-dialog
        :dialogOpen="addTemporalDialog"
        :idUsuario="this.$route.params.id"
        @toggleDialog="toggleAddTemporal"
        @applyDialog="applyAddTemporal"
        :labelOrigen="$t('app.origen_groups')"
        :labelDestino="$t('app.destino_groups')"
        :title="$t('configurations.add_temporal_groups')"
        />
      <filter-panel :panelOpen="filterPanel" @togglePanel="toggleFilters" @applyFilters="applyFiltersHandler" />
      <create-search-dialog 
        :numberSearches="numberSearches"
        :idVista="idVista" 
        :dialogOpen="saveSearchDialog" 
        :tags="tags" 
        @toggleDialog="toggleDialogSearches" 
        @applyDialog="applySearchHandler" />
      <filter-panel-searches 
        ref="filterPanelSearches" 
        :idVista="idVista" 
        :vuexnamespace="vuexnamespace" 
        :panelOpen="searchesPanel" 
        @togglePanel="toggleSearchesDialog" 
        @applyFilters="applyFiltersHandler" 
        @updateNumberSearches="updateNumberSearches"/>
    </template>
  </list-layout>
</template>

<script>
import { bus } from '@/main'
import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanel from '@/components/filters/GroupsFilterByUser.vue'
import FilterPanelSearches from '@/components/searches/SearchesPanel.vue'
import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'
import { i18n } from '@/i18n'
import { process } from '@progress/kendo-data-query'
import KendoGridComponent from '../../components/KendoGridComponent.vue'
import UserLinkGroupsDialog from '@/components/UserLinkGroupsDialog.vue'
import UserLinkUsersDialog from '@/components/UserLinkUsersDialog.vue'

import { getUser } from '@/services/configurations/getUser'

import { gGetUserGruposPag } from '@/services/configurations/groups/gGetUserGruposPag'
import { gGetUserGruposExcel } from '@/services/configurations/groups/gGetUserGruposExcel'

import { linkUserToGroups } from '@/services/configurations/groups/linkUserToGroups'
import { unlinkUserGroups } from '@/services/configurations/groups/unlinkUserGroups'
import { removeTemporalesGroups } from '@/services/configurations/groups/removeTemporalesGroups'
import { addTraspasoGroups } from '@/services/configurations/groups/addTraspasoGroups'

export default {
  name: 'groups-by-user',
  components: {
    ListLayout,
    FilterPanel,
    FilterPanelSearches,
    CreateSearchDialog,
    KendoGridComponent,
    UserLinkGroupsDialog,
    UserLinkUsersDialog
  },
  data: function () {
    return {
      idVista: 48,
      // Searches
      numberSearches: 0,
      saveSearchDialog: false,
      searchesPanel: false,
      // All
      loadingExcel: false,
      showModal: false,
      linkGroupToUserDialog: false,
      addTemporalDialog: false,
      spanish: true,
      header: {
        title: i18n.t('app.groups_link'),
        icon: 'config',
        breadcrumb: null,
        url: 'configurations/users/details'
      },
      vuexnamespace: 'usergroups',
      selectedField: 'selected',
      filterPanel: false,
      showAllRows: true,
      loadingDataTable: false,
      data: null,
      selected: [],
    }
  },
  computed: {
    labelBtnExcel: function () {
      if (this.hasSelected) return this.$i18n.t('app.export_excel') + ' (Seleccionados)'
      return this.$i18n.t('app.export_excel')
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    toggleTableTools: function () {
      return this.selected.length > 0
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.selected.length
    },
    setLabelTowShow: function () {
      return this.showAllRows ? 'Solo Seleccionadas' : 'Ver Todas'
    },
    masterFilters: function () {
      return this.$store.getters[this.vuexnamespace + '/getMasterFilters']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    headerCoreFilters: function () {
      return this.$store.getters['auth/queryHeaders']
    },
    tags: function () {
      return this.$store.getters[this.vuexnamespace + '/getTags']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    columns () {
      return [
        { field: 'selected', width: '50px', headerSelectionValue: this.areAllSelected, reorderable: false, groupable: false },
        ...this.kendo.columns
      ]
    },
    areAllSelected () {
      return this.data.length === this.selected.length
    },
    hasSelected () {
      return this.selected.length > 0
    },
    role: function () {
      return this.$store.getters['auth/role']
    }
  },
  watch: {
    headerCoreFilters: {
      // immediate: true,
      deep: true,
      handler: 'headerCoreFiltersHandler'
    },
    data (val, oldVal) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group
      }
      this.kendo.dataResult = process(val, dataState)
      this.unselect()
    }
  },
  created: function () {
    // console.log('created: ')
  },
  mounted: async function () {
    const userId = this.$route.params.id

    // this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
    // this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
    this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)

    const breadcrumbs = []
    if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
      breadcrumbs.push({
        path: this.role === 'SuperAdministrador' ? 'configurationssa' : 'configurations',
        name: this.$i18n.t('app.configurations')
      })
    } else {
      breadcrumbs.push({
        path: 'configurations',
        name: this.$i18n.t('app.configurations')
      })
    }
    breadcrumbs.push({ path: 'configurations/users', name: this.$i18n.t('app.users') })
    
    const user = await this.downloadData(userId)
    breadcrumbs.push({ path: '', name: user.Usuario })
    this.$store.commit('app/setheaderBreadCrumb', user.Usuario)
    this.disableRoutes(user)

    this.header.breadcrumb = breadcrumbs

    this.data = await this.applyFilters()
  },
  methods: {
    toggleAddTemporal () {
      this.addTemporalDialog = !this.addTemporalDialog
    },
    applyAddTemporal: async function ({ users, radioOrigen, radioDestino }) {
      try {
        this.$store.commit('setIsLoading', true)
        const idUsuario = this.$route.params.id
        const payload = {
          idUsuario: idUsuario,
          idUsuarios: users,
          TemporalOrigen: radioOrigen,
          TemporalDestino: radioDestino,
        }
        const response = await addTraspasoGroups(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.applyFilters()
          this.doFeedback('Traspaso realizado correctamente', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.toggleAddTemporal()
        this.$store.commit('setIsLoading', false)
      }
    },
    deleteTemporal: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const idUsuario = this.$route.params.id
        const response = await removeTemporalesGroups({ idUsuario: idUsuario })
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.applyFilters()
          this.doFeedback('Temporales eliminados correctamente', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    disableRoutes: function (user) {
      const isDisabledByRol = (user.Rol === 'AdminDistribuidor' || user.Rol === 'SuperAdminDistribuidor' || user.Rol === 'SuperAdministrador')
      const objDisableRoutes = {
        disableGroups: isDisabledByRol,
        disableStatuses: user.VerTodoEstados || isDisabledByRol,
        disableCompanies: user.VerTodoEmpresas || isDisabledByRol,
      }
      bus.$emit('disableOptionsUser', objDisableRoutes)
    },
    updateAllSelectedHeader: function () {
      if (!this.hasSelected) {
        this.kendo.columns[0].headerSelectionValue = false
      } else {
        this.kendo.columns[0].headerSelectionValue = this.areAllSelected
      }
    },
    openPath: function (event) {
      // console.log('Ir a registro con ID: ', event.dataItem.id)
      // this.$router.push({ name: 'configurations/tags/details', params: { id: event.dataItem.IdUsuario } })
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    toggleDialogs: function () {
      this.linkGroupToUserDialog = !this.linkGroupToUserDialog
    },
    removeFilterTag: function (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    createAppState: function (dataState) {
      this.kendo.take = dataState.take
      this.kendo.skip = dataState.skip
      if (dataState.group) {
        // eslint-disable-next-line no-return-assign
        // dataState.group.map(group => group.aggregates = this.aggregates)
      }
      this.kendo.group = dataState.group
      this.kendo.filter = dataState.filter
      this.kendo.sort = dataState.sort
    },
    dataStateChange: async function (event) {
      this.createAppState(event.data)
      this.data = await this.applyFilters()
    },
    columnReorder: function (options) {      
      this.sendUpdatedColumns(options.columns)
      this.kendo.columns.forEach((column, index) => {
        if (options.columns.filter(x => x.field === column.field).length === 0) {
          column.orderIndex = index + this.kendo.columns.length
          options.columns.push(column)
        }
      })
      this.kendo.columns = options.columns
    },
    exportExcel: async function () {
      this.$store.commit('app/setLoading', true)
      this.loadingExcel = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        idUsuario: this.$route.params.id,
        temporal: data.temporal ? data.temporal.value : null,
        nombre: data.name ? data.name.value : null,
        tipo: data.tipoGrupo ? data.tipoGrupo.value : null,
        VerTodoGrupos: data.verTodoGroups ? data.verTodoGroups.value : null,
        VerTodoEstados: data.verTodoStatuses ? data.verTodoStatuses.value : null,
        VerTodoEmpresas: data.verTodoCompanies ? data.verTodoCompanies.value : null,
        verTodoAsignarGrupos: data.verTodoAsignarGrupos ? data.verTodoAsignarGrupos.value : null, 
        emailGenerico: data.email ? data.email.value : null,
        numeroSMSGenerico: data.phone ? data.phone.value : null,
        enviarAvisos: data.send_alerts ? data.send_alerts.value : null,
        enviarAvisosUsuarios: data.enviarAvisosUsuarios ? data.enviarAvisosUsuarios.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      const objColumnas = this.getColumnsGroupExcelMixin(this.kendo.columns, this.kendo.group)
      const payload = { order: objOrder.order, grupos: objColumnas }
      if (this.hasSelected) {
        const selectedIDs = this.selected.map(x => x.IdGrupo)
        payload.listaIDs = selectedIDs
      }
      try {
        const response = await gGetUserGruposExcel(payload, params)
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'usuario-grupos.xlsx'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loadingExcel = false
      }
    },
    onColumnsSubmit: function (columnsState) {
      this.sendUpdatedColumns(columnsState)
      this.kendo.columns = columnsState
    },
    sortChange: function (e) {
      let sort = e.sort
      if (Array.isArray(e)) {
        sort = e
      }
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: sort,
        group: this.kendo.group,
        filter: this.kendo.filter
      }
      this.dataStateChange({ data: dataState })
    },
    filterChange: function (filter) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group,
        filter: filter
      }

      this.dataStateChange({ data: dataState })
    },
    expandChange: function (event) {
      event.dataItem[event.target.$props.expandField] = !event.dataItem[event.target.$props.expandField]
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        idUsuario: this.$route.params.id,
        temporal: data.temporal ? data.temporal.value : null,
        nombre: data.name ? data.name.value : null,
        tipo: data.tipoGrupo ? data.tipoGrupo.value : null,
        VerTodoGrupos: data.verTodoGroups ? data.verTodoGroups.value : null,
        VerTodoEstados: data.verTodoStatuses ? data.verTodoStatuses.value : null,
        VerTodoEmpresas: data.verTodoCompanies ? data.verTodoCompanies.value : null,
        verTodoAsignarGrupos: data.verTodoAsignarGrupos ? data.verTodoAsignarGrupos.value : null, 
        emailGenerico: data.email ? data.email.value : null,
        numeroSMSGenerico: data.phone ? data.phone.value : null,
        enviarAvisos: data.send_alerts ? data.send_alerts.value : null,
        enviarAvisosUsuarios: data.enviarAvisosUsuarios ? data.enviarAvisosUsuarios.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      try {
        this.data = await this.getItemsData(objOrder, params)
      } catch (error) {
        // console.log('error', error)
        this.$store.commit('setIsLoading', false)
        this.doFeedback(this.$i18n.t('feedback.error.general ' + error))
      }
      this.updateAllSelectedHeader()
      return this.data
    },
    getItemsData: async function (objOrder, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(objOrder, params)
      this.data = res.Respuesta
      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      
      this.updatePersistedSortMixin()
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false
      return this.data
    },
    async getMainData (objOrder, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const data = await gGetUserGruposPag(objOrder, params)
      if (data.blnError === true) {
        this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
      } else {
        setTimeout(() => {
          this.$nextTick(() => { 
            if (this.$refs.baseTablePagRef) this.$refs.baseTablePagRef.focus() 
          })
          this.doFeedback('Se han refrescado los datos del grid actual', 'info', 3000, true)
        }, 200)
      }
      data.Respuesta.forEach(o => {
        o.DiasAviso = o.DiasAviso === null ? 'Desactivado' : o.DiasAviso
        o.DiasFinTramite = o.DiasFinTramite === null ? 'Desactivado' : o.DiasFinTramite
      })
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters(null)
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      this.data = await this.applyFilters(null)
    },
    removeFilterTagHanlder: function (tag) {
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.applyFiltersHandler(null)
    },
    headerCoreFiltersHandler: function (obs) {
      if (this.isHeadCoreReady) {
        this.applyFilters(null)
      }
    },
    removeAllTagsHandler: function () {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.applyFiltersHandler(null)
    },
    tableSortByChangeHandler: function ({ prop, order }) {
      this.$store.commit(this.vuexnamespace + '/setSort', prop)
      this.$store.commit(this.vuexnamespace + '/setSortOrder', order)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.applyFilters(null)
    },
    downloadData: async function (id) {
      let user = null
      try {
        this.$store.commit('setIsLoading', true)

        const params = {
          idUsuario: id
        }
        user = await getUser(params)
        if (user.blnError === true) {
          this.doFeedback(user.msgError + ' [Código de error: ' + user.codError + ']')
        } else {
          user = user.respuesta
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return user
    },
    unselect: function () {
      const checked = false
      this.mapSelectionKendoGrouping(checked)
      this.updateAllSelectedHeader()
    },
    unlink: async function () {
      const selected = this.selected
      await this.unlinkHandler(selected)
      // for await (const element of selected) {
      //   await this.unlinkHandler(element.IdTag)
      // }
      this.data = await this.applyFilters()
    },
    unlinkHandler: async function (grupos) {
      // console.log('unlinkHandler', tags)
      try {
        this.$store.commit('setIsLoading', true)
        const idUsuario = this.$route.params.id
        const payload = { idUsuario: idUsuario, idGrupos: [] }
        grupos.forEach(element => {
          payload.idGrupos.push(element.IdGrupo)
        })
        const response = await unlinkUserGroups(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Desvinculado correctamente', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    golinkTagToUser: function () {
      this.linkGroupToUserDialog = !this.linkGroupToUserDialog
    },
    onHeaderSelectionChange: function (event) {
      const checked = event.event.target.checked
      this.mapSelectionKendoGrouping(checked)
      this.updateAllSelectedHeader()
    },
    onSelectionChange: function (event) {
      event.dataItem[this.selectedField] = !event.dataItem[this.selectedField]
      this.selected = event.dataItems.filter(d => d.selected === true)
      this.updateAllSelectedHeader()
    },
    applyLinkHandler: async function (tags) {
      this.linkTagToUser = false
      // console.log('applyLinkHandler', tags)
      await this.linkHandler(tags)
      this.applyFilters()
    },
    linkHandler: async function (idGrupos) {
      try {
        this.$store.commit('setIsLoading', true)
        const idUsuario = this.$route.params.id
        const payload = { idUsuario: idUsuario, idGrupos: idGrupos }
        const response = await linkUserToGroups(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.toggleDialogs()
          this.doFeedback('Vinculado correctamente', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    toggleSearchesDialog: function () {
      this.searchesPanel = !this.searchesPanel
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
  }
}
</script>

<style lang="scss" scoped></style>
